import { FilterXSS } from 'xss';

const options: XSS.IFilterXSSOptions = {
  whiteList: {
    // very important we keep these, they're key to the @mentions working and rendering
    span: ['contenteditable', 'data-target-id', 'data-target-type'],
    // some more tags we'll allow, mainly for the different linebreaks that various browsers might insert
    br: [],
    div: [],
    p: [],
  },
  stripIgnoreTag: true,
};
export const sanitizer = new FilterXSS(options);

// export function sanitizer(html: string) {
//   return xss(html, options);
// }
